import { CampaignTypes, formUrl, ICampaignTemplate } from '@pharmaplan/common';
import { CampaignEmailTemplates } from '@pharmaplan/common/reducers/utilsReducer';

const useTransformCampaignTemplates = () => {
  const defaultTemplateMapConfig = {
    [CampaignTypes.LeadCampaignInvite]: {
      englishSubject: null,
      englishBody: null,
      frenchSubject: 'registrationEmailTemplatesubjectfr',
      frenchBody: 'registrationEmailTemplatebodyfr',
    },

    [CampaignTypes.UserCreditsInvite]: {
      englishSubject: null,
      englishBody: null,
      frenchSubject: 'existingUserEmailTemplatesubjectfr',
      frenchBody: 'existingUserEmailTemplatebodyfr',
    },

    [CampaignTypes.Activation]: {
      englishSubject: 'activationEmailTemplatesubjecten',
      englishBody: 'activationEmailTemplatebodyen',
      frenchSubject: 'activationEmailTemplatesubjectfr',
      frenchBody: 'activationEmailTemplatebodyfr',
    },

    [CampaignTypes.SingleBooking]: {
      englishSubject: 'bookingEmailTemplatesubjecten',
      englishBody: 'bookingEmailTemplatebodyen',
      frenchSubject: 'bookingEmailTemplatesubjectfr',
      frenchBody: 'bookingEmailTemplatebodyfr',
    },

    [CampaignTypes.ContractBooking]: {
      englishSubject: 'multiBookingEmailTemplatesubjecten',
      englishBody: 'multiBookingEmailTemplatebodyen',
      frenchSubject: 'multiBookingEmailTemplatesubjectfr',
      frenchBody: 'multiBookingEmailTemplatebodyfr',
    },
  } as const;

  const imageTemplateConfig = (state: CampaignEmailTemplates) =>
    ({
      [formUrl.activationEmailUrl]: state.activationEmailImage,
      [formUrl.bookingEmailUrl]: state.bookingEmailImage,
      [formUrl.registrationEmailUrl]: state.registrationEmailImage,
      [formUrl.registrationPopupUrl]: state.registrationPopupImage,
    });

  const stateToTemplateArray = (
    state: CampaignEmailTemplates,
  ) =>
    Object.entries(defaultTemplateMapConfig).map(
      ([templateType, mapping]) =>
        ({
          templateType: Number(templateType),

          englishSubject:
          mapping.englishSubject
            ? state[mapping.englishSubject]
            : '',

          englishBody:
          mapping.englishBody
            ? state[mapping.englishBody]
            : '',

          frenchSubject:
          mapping.frenchSubject
            ? state[mapping.frenchSubject]
            : '',

          frenchBody:
          mapping.frenchBody
            ? state[mapping.frenchBody]
            : '',
        }),
    );

  const templateArrayToState = (
    templates: ICampaignTemplate[],
    state: CampaignEmailTemplates,
  ) => {
    const result = { ...state };
    templates.forEach((template) => {
      const mapping = defaultTemplateMapConfig[
        template.templateType as keyof typeof defaultTemplateMapConfig
      ];

      if (!mapping) {
        return;
      }

      if (mapping.englishSubject) {
        result[mapping.englishSubject] = template?.englishSubject;
      }

      if (mapping.englishBody) {
        result[mapping.englishBody] = template?.englishBody;
      }

      if (mapping.frenchSubject) {
        result[mapping.frenchSubject] = template?.frenchSubject;
      }

      if (mapping.frenchBody) {
        result[mapping.frenchBody] = template?.frenchBody;
      }
    });

    return result;
  };

  return { stateToTemplateArray, templateArrayToState, defaultTemplateMapConfig, imageTemplateConfig };
};

export default useTransformCampaignTemplates;
